import { Icon, Span } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import styles from './style.module.css'
import { useAddFirstPaymentMethodExperiment, useCheckoutState } from '../../state'
import clsx from 'clsx'
import { useCheckoutSizes } from '../../utils/responsive'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { CheckoutStatus } from '../../model'

export const PaymentMethodNoCard: FunctionComponent = () => {
  const { status } = useCheckoutState()
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()

  // add first payment method experiment
  const isCheckoutStatusFirstPaymentMethodRequired = status === CheckoutStatus.FirstPaymentMethodRequired
  const isAddFirstPaymentMethodExperimentC = useAddFirstPaymentMethodExperiment('ExperimentC', isCheckoutStatusFirstPaymentMethodRequired)
  const isAddFirstPaymentMethodExperimentEnabled = isAddFirstPaymentMethodExperimentC && isCheckoutStatusFirstPaymentMethodRequired

  const textContainerClasses = clsx(styles.textContainer, isAddFirstPaymentMethodExperimentEnabled && styles.marginLeft)

  const renderText = (): string => {
    return isAddFirstPaymentMethodExperimentEnabled ? t('common:changePaymentMethodUsExperiment') : t('common:changePaymentMethod')
  }

  return (
    <span className={styles.container}>
      {isAddFirstPaymentMethodExperimentEnabled && (
        <>
          <span>
            <Icon.Warning size='Small' color='Lemon Dark' />
          </span>
          <TrackOnMount eventName={TrackingEvent.VIEWED_ADD_FIRST_PAYMENT_EXPERIMENT} eventProperties={{ variant: 'C' }} />
        </>
      )}
      <span className={textContainerClasses}>
        <Span size={textSize} bold>
          {renderText()}
        </Span>
      </span>
    </span>
  )
}
